<div  style="width: 100%;">
  <h2 mat-dialog-title>
    <ng-container *ngIf="!editingTitle; else editMode">
      {{ report.rep_title }}
      <button (click)="toggleEditTitle()" aria-label="Edit title" class="edit-button">
        <mat-icon>edit</mat-icon>
      </button>
    </ng-container>

    <ng-template #editMode>
      <input [(ngModel)]="report.rep_title" (keydown.enter)="toggleEditTitle()" class="mat-dialog-title"
        style="font: inherit; border: none; outline: none; width: auto;" />
      <button (click)="toggleEditTitle()" aria-label="Done editing" class="edit-button">
        <mat-icon>done</mat-icon>
      </button>
    </ng-template>
  </h2>

  <mat-dialog-content class="dialog-content">
    <app-p-ticket-filter [activeFilters]="activeFilters" [persistInLocalStorage]="false"
      (httpFilterList)="onFilterChange($event)">
    </app-p-ticket-filter>

    <div class="selction-wrapper">
      <mat-form-field class="input-formfield">
        <mat-label>Chart Type</mat-label>
        <mat-select (valueChange)="onTypeChange($event)" [(ngModel)]="report.rep_chartType">
          <mat-option value="bar">Bar</mat-option>
          <mat-option value="line">Line</mat-option>
          <mat-option value="pie">Pie</mat-option>
          <mat-option value="doughnut">Doughnut</mat-option>
          <mat-option value="radar">Radar</mat-option>
        </mat-select>
      </mat-form-field>

      <mat-form-field class="input-formfield">
        <mat-label>X Axis</mat-label>
        <mat-select (valueChange)="onXAxisChange($event)" [(ngModel)]="report.rep_xAxisOption.key">
          <mat-option *ngFor="let option of xAxisOptions" [value]="option.key">{{ option.label }}</mat-option>
        </mat-select>
      </mat-form-field>
    </div>

    <div class="graph-container">
      <app-reporting-graph [report]="report"></app-reporting-graph>
    </div>
  </mat-dialog-content>
  <mat-dialog-actions>
    <button mat-flat-button (click)="cancel()" [disabled]="isSavingChanges">Cancel</button>
    <button mat-raised-button color="primary" (click)="save()" [disabled]="isSavingChanges">Save</button>
  </mat-dialog-actions>
</div>